import React from 'react'

const NotFound = () => {
  return (
    <div className='page-sm'>
      <h1>NotFound</h1>
    </div>
  )
}

export default NotFound